import React from 'react'
import { Button, Icon } from '@lightspeed/design-system-react'
import type { DeleteButtonProps } from './DeleteButtonProps'

export const DeleteButtonLegacy: React.FC<DeleteButtonProps> = ({
  modifier,
  variant,
  className,
  disabled,
  onClick,
  type,
  id,
  'aria-label': ariaLabel,
  'data-track': dataTrack,
  'data-testid': dataTestId,
}) => (
  <Button
    onClick={onClick}
    modifier={modifier}
    variant={variant}
    className={className}
    disabled={disabled}
    type={type}
    id={id}
    aria-label={ariaLabel}
    data-track={dataTrack}
    data-testid={dataTestId}
  >
    <Icon icon="trash" />
  </Button>
)
